import gql from 'graphql-tag'

export const QueryGetPreferences = gql(`query preferences {
    getPreferences {
      user_id
      lang
      state
      needs_sync @client
    }
  }`)

export const QueryGetPreferencesFromCache = gql(`query preferences {
    getPreferences @client {
      user_id
      lang
      state
      needs_sync
    }
  }`)



// WEBPACK FOOTER //
// ./src/graphql/QueryGetPreferences.js